import { render } from "./DashboardRight.vue?vue&type=template&id=4028c2a4&scoped=true"
import script from "./DashboardRight.vue?vue&type=script&lang=js"
export * from "./DashboardRight.vue?vue&type=script&lang=js"

import "./DashboardRight.vue?vue&type=style&index=0&id=4028c2a4&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4028c2a4"]])

export default __exports__